import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'color-text-column',
  template: `<color-text [text]="value" [config]="config"></color-text>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorTextColumnComponent implements OnInit {

  @Input()
  searchTerm;
  @Input()
  columnValue;
  @Input()
  columnData;

  value: string;
  config;

  ngOnInit() {
    this.value = this.columnValue[this.columnData.columnName];
    this.config = this.columnData.configuration;
  }
}
